$(document).ready(function(){
  
  
  $(document.body).on('click','.addtocartbutton', function(e) {
//e.preventDefault();	 
var variantid=$(this).data("variantid");
$.ajax({ 
      
    url:"/cart/add.js",
	data: {quantity:1,id:variantid},
	dataType: 'json',
	error: function(data){ alert('Please choose a variant before adding this item to cart'); alert(data.responseJSON.description)},
	success:function(data){
         $.ajax({  
          type:'GET',
          url:'/cart',
          dataType:'html',
          success:function(ddata){
            var minicartdata = $(ddata).filter('#CartDrawer').html();
            $('#CartDrawer').html(minicartdata);
            $("#CartDrawer").addClass("open-cart");
            setTimeout(function(){$('#af_cart_slider').insertBefore('.checkout');}, 1000);
            $(".overlay_1").show();
            $("#AddToCartText").text('Add to Cart');
            $("#add-cart").removeAttr("disabled");
            $('.loading-modal').hide();
           close();
           agre();
           slider();
           remove();
           plus();
            minus();
            upsell_add();
            upsell2_add();
           no_upsell();
           col_add();
            addGift();
            check();
            checkCartForDisguiseConditions();
            updateDrawerShippingDisplay();
            clear();
            var get = sessionStorage.getItem("clock");
            if(get != 'start')
            {
              timer();
              sessionStorage.setItem("clock", "start");
            }
          }
        });
    
    
    }});	
});
  
  
  
  $("#ToggleDown,.cart-page-link").on("click",function(e){
      e.preventDefault();
      $(".overlay_1").show();
      $("#CartDrawer").addClass("open-cart");

  });
  
  $(".overlay_1").on("click",function(){
    if($("#CartDrawer").hasClass("open-cart"))
    {
      $("#CartDrawer").removeClass("open-cart");
      $(".overlay_1").hide();
    }
  });
  
   function close(){
     $(".cart-drawer .close").on("click",function(){
       $("#CartDrawer").removeClass("open-cart");
       $(".overlay_1").hide();
     });
   }
  
  close();
  
  function agre(){
  	$("#agre").on("change",function(){
      if($(this).is(":checked"))
      {
        $(".checkout").find("form").removeClass("disable");
      }
      else
      {
        $(".checkout").find("form").addClass("disable");
      }      
    });
    $(".checkout").on("click",function(){
      if(!$("#agre").is(":checked"))
      {
        alert("Please accept the Terms and Conditions! ");
      }
    })
  }
  
  agre();
  
  function remove(){

    $(".remove").on("click",function(){
      
     var id = $(this).attr("data-id");
      var quantity = 0;
//       $(".overlay").show();
      update_cart(id,quantity);
    });
  }
  remove();
  function no_upsell(){
  
    $(".upsell2-btn div.upsell2-button:not(:first)").hide();
  $(".upsell2_add").click(function() {  //use a class, since your ID gets mangled
    $(this).addClass("active-btn");
  });
  }
  no_upsell();
  
  
  function plus(){
    $(".item-info").find(".qtyplus1").on("click",function(e){
      e.preventDefault();
      var gift = $(".gift-product").length;
      if(gift < 1)
      {
        
        var value = $(this).siblings("input[type=number]").val();
        var value = parseInt(value) + 1;
        if(value != 0)
        {
          $(this).siblings("input[type=number]").val(value);
          var id = $(this).siblings("input[type=number]").attr("data-id");
  //         $(".overlay").show();
          update_cart(id,value);
        }
      }
      else
      {
        $(".gift-product-error").show();
      }
    });
    $(".upsell-btn").find(".qtyplus1").on("click",function(e){
      e.preventDefault();
      var value = $(this).siblings("input[type=number]").val();
      var value = parseInt(value) + 1;
      if(value != 0)
      {
        $(this).siblings("input[type=number]").val(value);
      }
    });
    $(".upsell2-btn").find(".qtyplus1").on("click",function(e){
      e.preventDefault();
      var value = $(this).siblings("input[type=number]").val();
      var value = parseInt(value) + 1;
      if(value != 0)
      {
        $(this).siblings("input[type=number]").val(value);
      }
    });
    $(".cart-upsell-slider").find(".qtyplus1").on("click",function(e){
      e.preventDefault();
      var value = $(this).siblings("input[type=number]").val();
      var value = parseInt(value) + 1;
      if(value != 0)
      {
        $(this).siblings("input[type=number]").val(value);
      }
    });
  }
  plus();
  
  function minus(){
  	$(".item-info").find(".qtyminus1").on("click",function(e){
      e.preventDefault();
      var gift = $(".gift-product").length;
      if(gift < 1)
      {
      var value = $(this).siblings("input[type=number]").val();
      var value = parseInt(value) - 1;
      if(value != 0)
      {
       $(this).siblings("input[type=number]").val(value);
        var id = $(this).siblings("input[type=number]").attr("data-id");
//         $(".overlay").show();
        update_cart(id,value);
      }
      }
      else
      {
        $(".gift-product-error").show();
      }
    });
    $(".upsell-btn").find(".qtyminus1").on("click",function(e){
      e.preventDefault();
      var value = $(this).siblings("input[type=number]").val();
      var value = parseInt(value) - 1;
      if(value != 0)
      {
        $(this).siblings("input[type=number]").val(value);
      }
    });
    $(".upsell2-btn").find(".qtyminus1").on("click",function(e){
      e.preventDefault();
      var value = $(this).siblings("input[type=number]").val();
      var value = parseInt(value) - 1;
      if(value != 0)
      {
        $(this).siblings("input[type=number]").val(value);
      }
    });

    $(".cart-upsell-slider").find(".qtyminus1").on("click",function(e){
      e.preventDefault();
      var value = $(this).siblings("input[type=number]").val();
      var value = parseInt(value) - 1;
      if(value != 0)
      {
        $(this).siblings("input[type=number]").val(value);
      }
    });
  }
  minus();
  
  function upsell_add(){
    $(".upsell_add").on("click",function(){
      var val = $(".upsell-info").find("select").val();
      var id = $(".upsell-info").find("select option[value='"+val+"']").attr("data-id");
      var qty = $(".upsell-btn").find(".cart-number").val();
      var property = $('upsell-info').find('#estimated-delivery-date').val();
//       $(".overlay").show();
      buy(id,qty);
      
    });
  }
  upsell_add();
  function upsell2_add(){
    $(".upsell2_add").on("click",function(){
      var val = $(".upsell2-info").find("select").val();
      var id = $(".upsell2-info").find("select option[value='"+val+"']").attr("data-id");
      var qty = $(".upsell2-btn").find(".cart-number").val();
      var property = $('upsell-info').find('#estimated-delivery-date').val();
//       $(".overlay").show();
      buy(id,qty);
      
    });
  }
  upsell2_add();

function updateDrawerShippingDisplay() {
  const isMainlandUS = sessionStorage.getItem('isMainlandUS') === 'true';

  if (isMainlandUS) {
    $('.percentage-fill, .free-shipping-message').css('display', 'block');
  } else {
    $('.percentage-fill, .free-shipping-message').css('display', 'none');
  }
}
updateDrawerShippingDisplay();  
  
  function col_add(){
    $(".col-add").on("click",function(){
    	var id = $(this).attr("data-id");
        var qty = $(this).parent().siblings('.qty').find(".quantity").val();
            var property = $('upsell-info').find('#estimated-delivery-date').val();

//       	$(".overlay").show();
        buy(id,qty);
      	
    });
  }
  col_add();
 
  $("#AddToCart").attr("id","add-cart");
  $(".add-cart-btn").addClass("add-cart");
  $(".add-cart-btn").removeClass("add-cart-btn");
  $(".quick-view-text").on("click",function(){
    var vail2 = $(this).parents('.products').find(".btn-medium").text();
    var vail1 = $(this).parents('.products').hasClass("sold-out");
    setTimeout(function(){
      if(vail2 == 'Sold Out' || vail1 == true)
      {
        $(".quick-view").find('.add-cart').attr("disabled",'disabled');
        $(".quick-view").find('.add-cart').text(vail2);
        $(".quick-view").find('.add-cart').text('Sold Out');
      }
      $("#add-cart,.add-cart").click(function(e){
       e.preventDefault();
        e.stopPropagation();
        $("#AddToCartText").text('Adding...');
        $('.loading-modal').show();
        $('.overlay_1').show();
        $("#add-cart").attr("disabled","disabled");
        var data = $(this).parents('form').serialize();
        addtocart(data);
        $(".quick-view").hide();
      });
   },1000);
  })
  $("#add-cart,.add-cart").click(function(e){
    var vail = $("#add-cart").find('#AddToCartText').text();
    if(vail != 'Sold Out')
    {
      e.preventDefault();
      e.stopPropagation();
      $('.loading-modal').show();
      $('.overlay_1').show();
      $("#AddToCartText").text('Adding...');
      $("#add-cart").attr("disabled","disabled");
      var data = $(this).parents('form').serialize();
      addtocart(data);
    }
   
  });
  
  $(".fg20-atc-btn").on("click",function(e){
  	e.preventDefault();
    $('.loading-modal').show();
    $('.overlay_1').show();
    $("#AddToCartText").text('Adding...');
    var data = $(this).parents('form').serialize();
    addtocart(data);
  });
  
  function addGift(){
  $("#CartDrawer").find(".fg-add").on("click",function(e){
   e.preventDefault();
   var data = $(this).parents('form').serialize();
   addtocart(data); 
  });
  }
  addGift();
  
  function clear(){
    $(".clr").on("click",function(){
//         $(".overlay").show();
    	cart_clear();
    });
  }
  clear();
  
  function check(){
    $(".item-title").each(function(){
     var title = $(this).find(".h5").text();
      var title =$.trim(title);
      if(title == 'Ready Made Activator & Softener Bottle')
      {
        if(title.indexOf("Ready Made Activator & Softener Bottle") == -1)
        {
          $(".upsell").show();
        }
        else {
          $(".upsell").hide();
        }
      }
        else if(title == 'Disguise My Package!')
        {
        if(title.indexOf("Disguise My Package!") == -1)
        {
          $(".upsell2").css('display', 'block');
        }
        else {
          $(".upsell2").css('display','none');
        }
        }
    })
    
    var delgift = $("#del-gift").length;
	if(delgift == '1')
    {
      $(".check-btn1").remove();
    }
    else
    {
      $("#del-gift").hide();
    }
    
    $("#CartDrawer .linkmain").on("click",function(){
    	$(this).find("nav").toggle();
        $(this).find(".hover-cross").toggle();
        $(this).find(".hover-arrow").toggle();
    });
    
  }
  check();


function checkCartForDisguiseConditions() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Check items with "Disguise" in the title
      const hasSingleDisguiseItemWithOneQuantity = 
        cart.items.length === 1 && 
        cart.items[0].title.includes("Disguise") && 
        cart.items[0].quantity > 0;

      const hasMultipleItemsAndDisguiseWithMoreThanOneQuantity = 
        cart.items.length > 1 && 
        cart.items.some(item => item.title.includes("Disguise") && item.quantity > 1);

      // // Filter items with SKU containing "gift"
      // const giftItems = cart.items.filter(item => 
      //   item.sku && item.sku.toLowerCase().includes("gift")
      // );

      // Conditions for "gift" SKUs
      const cartContainsOnlyGiftItems = giftItems.length === cart.items.length;
      const cartHasMoreThanOneGiftItem = giftItems.length > 1;

      // Display alerts based on conditions
      if (hasSingleDisguiseItemWithOneQuantity) {
        alert("Your cart contains only 1 item with 'Disguise My Package'. Please delete it to continue.");
        $('div.checkout').hide();
      } else if (hasMultipleItemsAndDisguiseWithMoreThanOneQuantity) {
        alert("Your cart contains multiple items, and one 'Disguise My Package' item has a quantity greater than 1. Please delete it to continue.");
        $('div.checkout').hide();
      }
      // else if (cartContainsOnlyGiftItems) {
      //   alert("Your cart contains only gift items. Please add a non-gift item to proceed.");
      //   $('div.checkout').hide();
      // } else if (cartHasMoreThanOneGiftItem) {
      //   alert("Your cart contains more than 1 gift item. Please remove extra gift items to proceed.");
      //   $('div.checkout').hide();
      // }
      else {
        $('div.checkout').show();
      }
    })
    .catch(error => console.error('Error fetching cart data:', error));
}
checkCartForDisguiseConditions();



  
  var interval;
  //  timer
  function timer(){
  var timer2 = "10:00";
   interval = setInterval(function() {
    var timer = timer2.split(':');
    //by parsing integer, I avoid all extra string processing
    var minutes = parseInt(timer[0], 10);
    var seconds = parseInt(timer[1], 10);
    --seconds;
    minutes = (seconds < 0) ? --minutes : minutes;
    if (minutes < 0) clearInterval(interval);
    seconds = (seconds < 0) ? 59 : seconds;
    seconds = (seconds < 10) ? '0' + seconds : seconds;
    //minutes = (minutes < 10) ?  minutes : minutes;
    $('#countTime').html("0"+minutes + ':' + seconds);
    timer2 = minutes + ':' + seconds;
     if(timer2 == '0:00')
     {
        clearInterval(interval);
//        $('.clr').trigger("click");
     }
  }, 1000);
  }
  var clc = $(".cart-countr").length;
  if(clc == 1)
  {
    timer();
    sessionStorage.setItem("clock", "start");
  }
  
  function addtocart(data){
  	$.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: data,
      success: function(data) {
        $.ajax({
          type:'GET',
          url:'/cart',
          dataType:'html',
          success:function(ddata){
            var minicartdata = $(ddata).filter('#CartDrawer').html();
            $('#CartDrawer').html(minicartdata);
            $("#CartDrawer").addClass("open-cart");
            setTimeout(function(){$('#af_cart_slider').insertBefore('.checkout');}, 1000);
            $(".overlay_1").show();
            $("#AddToCartText").text('Add to Cart');
            $("#add-cart").removeAttr("disabled");
            $('.loading-modal').hide();
            close();
            agre();
            slider();
            remove();
            plus();
            minus();
            upsell_add();
            upsell2_add();
            no_upsell();
            col_add();
            addGift();
            check();
            checkCartForDisguiseConditions();
            updateDrawerShippingDisplay();            
            clear();
            var get = sessionStorage.getItem("clock");
            if(get != 'start')
            {
              timer();
              sessionStorage.setItem("clock", "start");
            }
          }
        });

     }
      
    });
  }
  function update_cart(variant_id,quantity)
  {
    $.ajax({
      type: 'POST', 
      url: '/cart/change.js',
      dataType: 'json', 
      data: 'quantity=' + quantity + '&id=' + variant_id,
      success: function(line_item) {
        $.ajax({
        type: "GET",
        url: "/cart",
        dataType: 'html',
        success: function(ddata) 
        {
          var minicartdata = $(ddata).filter('#CartDrawer').html();
            $('#CartDrawer').html(minicartdata);
            setTimeout(function(){$('#af_cart_slider').insertBefore('.checkout');}, 1000);
            close();
            agre();
            slider();
          	remove();
            plus();
            minus();
            $(".overlay").hide();
            upsell_add();
            upsell2_add();
            no_upsell();
            col_add();
            addGift();
            check();
          checkCartForDisguiseConditions();
            updateDrawerShippingDisplay();
            clear();
          	var clc = $(".cart-countr").length;
            if(clc == 0)
            {
              sessionStorage.setItem("clock", "");
              clearInterval(interval);
            }
        }
        });
      }
    });
  }
  function buy(variant_id,quantity)
  {
    console.log(variant_id);
    console.log(quantity);
    var estd = $('#estimated-delivery-date').val();
//    console.log(property);
    $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
//      data: 'quantity=' + quantity + '&id=' + variant_id,
      data: {
        quantity: quantity,
        id: variant_id,
          properties: {
            'Estimated delivery date': estd
  }
      },
      success: function(line_item) {
        $.ajax({
        type: "GET",
        url: "/cart",
        dataType: 'html',
        success: function(ddata) 
        {
          var minicartdata = $(ddata).filter('#CartDrawer').html();
            $('#CartDrawer').html(minicartdata);
            setTimeout(function(){$('#af_cart_slider').insertBefore('.checkout');}, 1000);
            close();
            agre();
            slider();
          	remove();
            plus();
            minus();
          	addGift();
            $(".overlay").hide();
            upsell_add();
            upsell2_add();
            no_upsell();
            col_add();
          	check();
          checkCartForDisguiseConditions();
            updateDrawerShippingDisplay();          
            clear();
            $('#CartDrawer').animate({scrollTop:0}, 'slow');
            return false;
        }
        });
      }
    });
  }
  
  function cart_clear(){
  	$.ajax({
      type: 'POST', 
      url: '/cart/clear.js',
      dataType: 'json', 
      success: function(line_item) {
        $.ajax({
        type: "GET",
        url: "/cart",
        dataType: 'html',
        success: function(ddata) 
        {
          var minicartdata = $(ddata).filter('#CartDrawer').html();
            $('#CartDrawer').html(minicartdata);
            close();
//             agre();
//             slider();
//           	remove();
//             plus();
//             minus();
             $(".overlay").hide();
          	sessionStorage.setItem("clock", "");
             clearInterval(interval);
//             upsell_add();
//             col_add();
        }
        });
      }
    });
    
  }
  
  function slider(){ 
  $(".slider_1").owlCarousel({
    pagination: false,
    autoWidth: true,
    stagePadding: 0,
    margin: 15,
    navigation: true,
    navigationText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
    items:1,
    itemsDesktop: [1199, 1],
        itemsDesktopSmall: [980, 1],
     itemsTablet: [630, 1],
    itemsMobile: [479, 1]
  });
  }
  
  slider();

  $(document).on("change", ".cart-upsell-slider .variant-select", function(e) {
    console.log("change");
    var wrapper = $(this).parents(".col-product");
    var price= $("option:selected", this).attr('data-price');
    wrapper.find(".variant-price span").html(price);
    wrapper.find(".col-add").attr("data-id", $("option:selected", this).attr('data-id'));
  });
  
});



